<template>
    <div>
        <Header></Header>
        <div class="container">
            <dealsDashBoard :dashBoard="dashBoard"></dealsDashBoard> 
            <div class="d-flex justify-content-between align-items-center">
                <div class="row my-2 stageFilterBorder" v-if="windowWidth>maxMobilSize">
                    <div class="d-flex justify-content-between align-items-center tabletSlide">
                        <div class="stageFilter"  role="group">
                            <v-popover  popoverClass="currencypop" :trigger="popoverTrigger" :delay="popoverDelay">
                                <button type="button" class="btn btn-click py-1 step0 w130" :class="{active:stageFilter=='all'}" @click="stageFilter='all'">{{$ml.get('ALL')}}<br/><b class="d-none d-lg-block staceFilterPrice">{{currencyLabel(defaultCurrency)}} {{formatPrice(totalValue)}}</b></button>
                                <template #popover>
                                    <label class="font-weight-bold hiza p-list-title">{{$ml.get('PRICE_LIST')}}</label>
                                    <ul class="list-group list-group-flush price-list ">
                                        <li class="list-group-item" v-for="(currency,index) in currenciesList('total')" v-bind:key="index"><div class="d-flex"><div class="curr-shortcode">{{currencyLabel(currency.currency)}} : {{currency.count}}</div><div>{{$ml.get('DEALS_TOTAL')}}</div><div class="ml-auto">{{currencySymbol(currency.currency)}} {{formatPrice(currency.price)}}</div></div></li>
                                    </ul>
                                </template>
                            </v-popover>
                            <v-popover  popoverClass="currencypop" :trigger="popoverTrigger" :delay="popoverDelay">
                                <button type="button" class="btn btn-click py-1 step1 w130" :class="{active:stageFilter==1}" @click="stageFilter=1"> <label class="p-0 m-0 btn-click">{{$ml.get('STEP_1')}}<br/><b v-if="stageInfo[1]!=undefined" class="d-none d-lg-block staceFilterPrice px-1">{{currencyLabel(defaultCurrency)}} {{formatPrice(stageInfo[1]['totalValue'])}}</b></label></button>
                                <template #popover>
                                    <label class="font-weight-bold hiza p-list-title">{{$ml.get('PRICE_LIST')}}</label>
                                    <ul class="list-group list-group-flush price-list ">
                                        <li class="list-group-item" v-for="(currency,index) in currenciesList(1)" v-bind:key="index"><div class="d-flex"><div class="curr-shortcode">{{currencyLabel(currency.currency)}} : {{currency.count}}</div><div>{{$ml.get('DEALS_TOTAL')}}</div><div class="ml-auto">{{currencySymbol(currency.currency)}} {{formatPrice(currency.price)}}</div></div></li>
                                    </ul>
                                </template>
                            </v-popover>
                            <v-popover  popoverClass="currencypop" :trigger="popoverTrigger" :delay="popoverDelay">
                                <button type="button" class="btn btn-click py-1 step2 w130" :class="{active:stageFilter==2}" @click="stageFilter=2"> <label class="p-0 m-0 btn-click">{{$ml.get('STEP_2')}}<br/><b v-if="stageInfo[2]!=undefined" class="d-none d-lg-block staceFilterPrice px-1">{{currencyLabel(defaultCurrency)}} {{formatPrice(stageInfo[2]['totalValue'])}}</b></label></button>
                                <template #popover>
                                    <label class="font-weight-bold hiza p-list-title">{{$ml.get('PRICE_LIST')}}</label>
                                    <ul class="list-group list-group-flush price-list ">
                                        <li class="list-group-item" v-for="(currency,index) in currenciesList(2)" v-bind:key="index"><div class="d-flex"><div class="curr-shortcode">{{currencyLabel(currency.currency)}} : {{currency.count}}</div><div>{{$ml.get('DEALS_TOTAL')}}</div><div class="ml-auto">{{currencySymbol(currency.currency)}} {{formatPrice(currency.price)}}</div></div></li>
                                    </ul>
                                </template>
                            </v-popover>
                            <v-popover  popoverClass="currencypop" :trigger="popoverTrigger" :delay="popoverDelay">
                                <button type="button" class="btn btn-click py-1 step3 w130" :class="{active:stageFilter==3}" @click="stageFilter=3"> <label class="p-0 m-0 btn-click">{{$ml.get('STEP_3')}}<br/><b v-if="stageInfo[3]!=undefined" class="d-none d-lg-block staceFilterPrice px-1">{{currencyLabel(defaultCurrency)}} {{formatPrice(stageInfo[3]['totalValue'])}}</b></label></button>
                                <template #popover>
                                    <label class="font-weight-bold hiza p-list-title">{{$ml.get('PRICE_LIST')}}</label>
                                    <ul class="list-group list-group-flush price-list ">
                                        <li class="list-group-item" v-for="(currency,index) in currenciesList(3)" v-bind:key="index"><div class="d-flex"><div class="curr-shortcode">{{currencyLabel(currency.currency)}} : {{currency.count}}</div><div>{{$ml.get('DEALS_TOTAL')}}</div><div class="ml-auto">{{currencySymbol(currency.currency)}} {{formatPrice(currency.price)}}</div></div></li>
                                    </ul>
                                </template>
                            </v-popover>
                            <v-popover  popoverClass="currencypop" :trigger="popoverTrigger" :delay="popoverDelay">
                                <button type="button" class="btn btn-click py-1 step4 w130" :class="{active:stageFilter==4}" @click="stageFilter=4"> <label class="p-0 m-0 btn-click">{{$ml.get('STEP_4')}}<br/><b v-if="stageInfo[4]!=undefined" class="d-none d-lg-block staceFilterPrice px-1">{{currencyLabel(defaultCurrency)}} {{formatPrice(stageInfo[4]['totalValue'])}}</b></label></button>
                                <template #popover>
                                    <label class="font-weight-bold hiza p-list-title">{{$ml.get('PRICE_LIST')}}</label>
                                    <ul class="list-group list-group-flush price-list ">
                                        <li class="list-group-item" v-for="(currency,index) in currenciesList(4)" v-bind:key="index"><div class="d-flex"><div class="curr-shortcode">{{currencyLabel(currency.currency)}} : {{currency.count}}</div><div>{{$ml.get('DEALS_TOTAL')}}</div><div class="ml-auto">{{currencySymbol(currency.currency)}} {{formatPrice(currency.price)}}</div></div></li>
                                    </ul>
                                </template>
                            </v-popover>
                            <v-popover  popoverClass="currencypop" :trigger="popoverTrigger" :delay="popoverDelay">
                                <button type="button" class="btn btn-click py-1 step5 w130" :class="{active:stageFilter==5}" @click="stageFilter=5"> <label class="p-0 m-0 btn-click">{{$ml.get('CONCLUDED')}}<br/><b v-if="stageInfo[5]!=undefined" class="d-none d-lg-block staceFilterPrice px-1">{{currencyLabel(defaultCurrency)}} {{formatPrice(stageInfo[5]['totalValue'])}}</b>   </label></button>
                                <template #popover>
                                    <label class="font-weight-bold p-list-title hiza">{{$ml.get('PRICE_LIST')}}</label>
                                    <ul class="list-group list-group-flush price-list ">
                                        <li class="list-group-item" v-for="(currency,index) in currenciesList(5)" v-bind:key="index"><div class="d-flex"><div class="curr-shortcode">{{currencyLabel(currency.currency)}} : {{currency.count}}</div><div>{{$ml.get('DEALS_TOTAL')}}</div><div class="ml-auto">{{currencySymbol(currency.currency)}} {{formatPrice(currency.price)}}</div></div></li>
                                    </ul>
                                </template>
                            </v-popover>
                        </div>
                    </div>
                </div>
                
                <!-- <button class="btn btn-danger" @click="opportunityImportBtn()">Tıkla</button> -->
            </div>
            
            <div class="row justify-content-between filtreAndTableSetting">
                <div class="d-flex" v-if="windowWidth>maxMobilSize">
                    <div class="float-left mr-2 d-none d-lg-block">
                        <div class="view d-flex bg-transparent">
                            <button type="button" v-tooltip="$ml.get('COLUMN_VIEW')" class="btn-crm-secondary btn btn-click p-2 dropdown-button h40 w40" @click="$router.push('deals')"> 
                                <i class="fas fa-columns font-m"></i>
                            </button>
                            <!-- <button type="button" v-tooltip="$ml.get('LIST_VIEW')" class="btn btn-click p-2 active"> 
                                <i class="fa fa-bars font-m"></i>
                            </button> -->
                        </div>
                    </div>
                    
                    <div class="float-left mr-2 table-setting" v-if="$can('can_bulk_delete_deals')||$can('can_bulk_update_deals')">
                        <button  type="button" :title="$ml.get('BULK_ACTIONS')" class="btn btn-crm-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> 
                            <label class="p-0 m-0 btn-click">{{$ml.get('BULK_ACTIONS')}}</label>
                            <!-- <i class="fa fa-caret-down font-m ml-2"></i> -->
                        </button>
                        <div class="dropdown-menu dropdown-menu-left dropMenu multiChoose p-0">
                            <ul class="new-dropdown p-0 border-0">
                                <li v-if="$can('can_bulk_update_deals')"  @click="openBulkUpdateModal()"><i class="fa fa-exchange h-14"></i> {{$ml.get('BULK_UPDATE')}}</li>
                                <li  v-if="$can('can_bulk_delete_deals')" class="text-danger" @click="deleteSelectedRows()"><i class="fa fa-trash h-14"></i> {{$ml.get('DELETE')}}</li>
                            </ul>
                        </div>
                    </div>
                    
                </div>
                <div class="d-flex align-items-end">
                    <div class=" addBtn" data-toggle="modal" data-target="#addOpportunity" @click="modalClear=false" >
                        <button type="button" class="btn btn-primary f-14 h40">
                            <i class="fa fa-plus f-14 mr-2"></i> {{$ml.get('ADD_OPORTUNITY')}}
                        </button>  
                    </div>

                    <!-- <button type="button" class="btn btn-link" data-toggle="modal" data-target="#importExcel">
                    {{$ml.get('IMPORT_EXCEL')}}
                    <i class="fas fa-file-import float-left pr-2 py-1">
                       
                    </i>
                    </button> -->

                    <filterComponent class="dealsFilterButton" @filter="filter=$event,getDealsForList('emitter')" ref="filter" :customFields="this.customFields" :users="this.users" :isUsersList="true" :dealStatus="true" :pageIs="pageIs"/>

                    <div class="float-left ml-2 table-setting" id="colListDD">
                        <button type="button" :title="$ml.get('SET_COLUMNS')" class="btn-crm-secondary btn btn-click p-2 dropdown-button h40 w40" data-toggle="dropdown"  aria-haspopup="true" aria-expanded="false"> 
                            <i class="fa fa-gear font-m "></i>
                        </button>
                         <!-- <button class=" btn btn-secondary"> 
                            <i class="fa fa-gear "></i>
                        </button> -->
                        
                        <div class="dropdown-menu dropdown-menu-right dropMenu multiChoose p-0">
                            <div class="p-2 mcBgDark">
                                <span class="text-white">{{selectedTableView.name}}</span>
                            </div>
                            <ul class="new-dropdown p-0 border-0">
                                <li class="p-0" v-for="col in gridColumns" v-show="(col['prop']!=='_id'&& col['prop']!=='discountPercentage' && col['prop']!=='itemPrice' && col['prop']!=='productList' && col['prop']!=='quantity' && col['prop']!=='x'&&col['prop']!=='notes'&&col['prop']!=='currency')">
                                    <label class="w-100 custom-checkbox">
                                        <input type="checkbox" :value="col['prop']" :disabled="tableConfigVisible.length <= 1 && tableConfigVisible.indexOf(col['prop']) != -1" v-model="tableConfigVisible"> 
                                        <span class="label-text f-14">{{col['name']}}</span>
                                    </label>
                                </li>
                            </ul>
                            <div class="dd-footer p-1">
                                <button type="button" data-toggle="modal"  data-target="#colListModal"  class="btn" style="background-color: #fff !important;color:#333333;border:1px solid #dcdddd">{{$ml.get('SAVED_VIEWS')}}</button>
                                <button @click="selectSaveMethod()" class="btn btn-primary" style="background-color:#1891eb !important"><i class="fa fa-save" ></i> {{$ml.get('SAVE')}}</button>
                            </div>
                        </div>
                    </div>

                    <div class="table-setting ml-2">
                        <button type="button" :title="$ml.get('SET_COLUMNS')" class="btn-crm-secondary btn btn-click p-2 dropdown-button h40 w40" data-toggle="dropdown"  aria-haspopup="true" aria-expanded="false"> 
                            <i class="fa fa-ellipsis-v font-m "></i>
                        </button>
                        <div class="dropdown-menu dropdown-menu-right dropMenu multiChoose p-0">
                            <ul class="new-dropdown p-0 border-0">
                                <li>
                                    <a type="button" class="" data-toggle="modal" data-target="#importExcel">
                                     {{$ml.get('IMPORT_EXCEL')}}
                                    <i class="fas fa-file-import float-left pr-2" style="padding-top:11px;">
                                        <!-- <img src="../assets/xls-icon.png" width="23px"> -->
                                    </i>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>

                  
                </div>
                
            </div>
            <div class="row my-3" v-if="windowWidth<maxMobilSize">
                <div class="align-self-center tabletSlide">
                    <div class="stageFilter">
                            <button type="button" class="btn btn-click py-1 step0" :class="{active:stageFilter=='all'}" @click="stageFilter='all'">{{$ml.get('ALL')}}<br/><b class="d-none d-lg-block">{{currencyLabel(defaultCurrency)}} {{formatPrice(totalValue)}}</b></button>
                            
                            <button type="button" class="btn btn-click py-1 step1" :class="{active:stageFilter==1}" @click="stageFilter=1"> <label class="p-0 m-0 btn-click">{{$ml.get('STEP_1')}}<br/><b v-if="stageInfo[1]!=undefined" class="d-none d-lg-block">{{currencyLabel(defaultCurrency)}} {{formatPrice(stageInfo[1]['totalValue'])}}</b></label></button>
                            
                            <button type="button" class="btn btn-click py-1 step2" :class="{active:stageFilter==2}" @click="stageFilter=2"> <label class="p-0 m-0 btn-click">{{$ml.get('STEP_2')}}<br/><b v-if="stageInfo[2]!=undefined" class="d-none d-lg-block">{{currencyLabel(defaultCurrency)}} {{formatPrice(stageInfo[2]['totalValue'])}}</b></label></button>
                            
                            <button type="button" class="btn btn-click py-1 step3" :class="{active:stageFilter==3}" @click="stageFilter=3"> <label class="p-0 m-0 btn-click">{{$ml.get('STEP_3')}}<br/><b v-if="stageInfo[3]!=undefined" class="d-none d-lg-block">{{currencyLabel(defaultCurrency)}} {{formatPrice(stageInfo[3]['totalValue'])}}</b></label></button>
                            
                            <button type="button" class="btn btn-click py-1 step4" :class="{active:stageFilter==4}" @click="stageFilter=4"> <label class="p-0 m-0 btn-click">{{$ml.get('STEP_4')}}<br/><b v-if="stageInfo[4]!=undefined" class="d-none d-lg-block">{{currencyLabel(defaultCurrency)}} {{formatPrice(stageInfo[4]['totalValue'])}}</b></label></button>
                            
                    </div>
                </div>
            </div>
            <div class="alert alert-secondary alert-dismissible fade show" v-if="totalCount == 0" role="alert">
                <strong>{{$ml.get('WARNING')}}</strong>
                {{$ml.get('NOT_FOUND_MESSAGE')}}
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <grid :data="gridData" @sortedData="getSortedData($event)" @updateCheckedRows="updateCheckedRows($event)" :tableConfigVisible="tableConfigVisible" :columns="gridColumns" :permissions="permissions" :user="user" :users="this.users" @scrolled="scrollfunctionOfGrid" :page="pageIs" v-if="windowWidth>maxMobilSize"></grid>
            <gridMobil :data="gridData" @sortedData="getSortedData($event)" @updateCheckedRows="updateCheckedRows($event)" :tableConfigVisible="tableConfigVisible" :columns="gridColumns" :permissions="permissions" :user="user" :users="this.users" @scrolled="scrollfunctionOfGrid" :page="pageIs" v-else></gridMobil>

            <div class="modal fade" ref="dealModal" id="addOpportunity" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document" style="max-width:750px!important">
                    <div class="modal-content crm-modal-content">
                        <newOpportunity :methods='type' @getData="getDealsForList('emitter')" :modalClear="modalClear" :user="this.user" :users="this.users" :customFieldArray="customFields"></newOpportunity>
                    </div>
                </div>
            </div>

            <div class="modal fade "  id="bulkUpdate" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="bulkUpdateModal" aria-hidden="true">
                <div class="modal-dialog modal-xl modal-dialog-centered" role="document" >
                    <div class="modal-content mcBgGrey">
                        <div class="modal-header border-0 mt-2 pb-0 align-items-center">
                            <h5 class="modal-title font-weight-bold">{{$ml.get('BULK_FIELD_UPDATE')}}</h5>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-4" v-for="(col,index) in bulkEditableColumnsCleaned" v-bind:key="index">
                                    <div class="input-group mb-3" v-if="col.prop!=='currency'">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">{{col.name}}</span>
                                        </div>
                                        <select class="custom-select" v-if="col.prop=='stageId'" v-model="col.val">
                                            <option value="">{{$ml.get('SELECT')}}</option>
                                            <option :value="step.value" v-for="(step,ind) in dealStepList" v-bind:key="ind">{{step.label}}</option>
                                        </select>
                                        <select class="custom-select" v-else-if="col.prop=='status'" v-model="col.val">
                                            <option value="">{{$ml.get('SELECT')}}</option>
                                            <option :value="st.value" v-for="(st,ind) in statusTitle" v-bind:key="ind">{{st.label}}</option>
                                        </select>
                                        <select class="custom-select" v-else-if="col.prop=='cuid'" v-model="col.val">
                                            <option value="">{{$ml.get('SELECT')}}</option>
                                            <option :value="user._id.$oid" v-for="(user,ind) in users" v-bind:key="ind">{{user.name}} {{user.surName}}</option>
                                        </select>
                                        <select class="custom-select" v-else-if="col.prop=='source'" v-model="col.val">
                                            <option :value="source.value" v-for="(source,ind) in soruceTitle" v-bind:key="ind">{{source.label}}</option>
                                        </select>
                                        <select class="custom-select" v-else-if="col.prop=='rate'" v-model="col.val">
                                            <option value="">{{$ml.get('SELECT')}}</option>
                                            <option :value="rate.value" v-for="(rate,ind) in rateTitle" v-bind:key="ind">{{rate.label}}</option>
                                        </select>
                                        <vue-ctk-date-time-picker :locale="localeLang" :button-now-translation="$ml.get('TODAY')" :id="col.prop" class="new-ctk ctk-ingroup" label="" v-else-if="col.prop=='expectedDate'||customFieldsProps.includes(col.prop)&&col.type=='3'"  v-model="col.val"  formatted="ll" :noLabel="true" :range="false" :onlyDate="true" :auto-close="true"></vue-ctk-date-time-picker>
                                        <input v-else-if="col.prop=='value'" type="text" class="form-control" v-model.number="col.val" :aria-describedby="col.name">
                                        <input v-else-if="customFieldsProps.includes(col.prop)&&col.type=='1'" type="text" class="form-control" v-model="col.val" :aria-describedby="col.name">
                                        <select class="custom-select" v-else-if="customFieldsProps.includes(col.prop)&&col.type=='4'" v-model="col.val">
                                            <option value="">{{$ml.get('SELECT')}}</option>
                                            <option :value="user._id.$oid" v-for="(user,ind) in col.users" v-bind:key="ind">{{user.name}} {{user.surName}}</option>
                                        </select>
                                        <div class="wper-60" v-else-if="customFieldsProps.includes(col.prop)&&col.type=='6'" >
                                            <button type="button" class="input-like-dd-button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                {{arrayToString(col.val, col.options, col.prop)}}
                                                <div class="input-plus-absolute-right">
                                                    <i @click="setRadio(col.prop,'clear',$event)" v-show="(col.val!==undefined&&col.val.length>0)"  class="fa fa-minus color-red cursor-pointer"></i>
                                                </div>
                                            </button>
                                            <div class="dropdown-menu dropMenu multiChoose p-0">
                                                <ul class="new-dropdown p-0">
                                                    <li v-for='(op,index) in col.options' v-bind:key="index">
                                                        <label class="w-100">
                                                            <input type="radio" :id="col.prop+'_op'+op.id" :value="op.id" v-model="col.radioVal" @input="setRadio(col.prop,'setvalue',$event)"> 
                                                            <span class="label-text" :title="op.label" :for="col.prop+'_op'+op.id">{{op.label}}</span>
                                                        </label>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="wper-60" v-else-if="customFieldsProps.includes(col.prop)&&col.type=='7'">
                                            <button type="button" class="input-like-dd-button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                {{arrayToString(col.val, col.options)}}
                                                <div class="input-plus-absolute-right">
                                                    <i @click="col.val=[]" v-show="(col.val!==undefined&&col.val.length>0)"  class="fa fa-minus color-red cursor-pointer"></i>
                                                </div>
                                            </button>
                                            <div class="dropdown-menu dropMenu multiChoose p-0">
                                                <ul class="new-dropdown p-0">
                                                    <li v-for='(op,index) in col.options' v-bind:key="index">
                                                        <label class="w-100">
                                                            <input type="checkbox" :id="col.prop+'_op'+op.id" :value="op.id" v-model="col.val"> 
                                                            <span class="label-text" :title="op.label" :for="col.prop+'_op'+op.id">{{op.label}}</span>
                                                        </label>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="wper-60" v-else-if="customFieldsProps.includes(col.prop)&&col.type=='8'" >
                                            <input type="text" class="form-control" :id="col.prop" @input="changeOrganizationArray($event)" v-model="col.selectedName">
                                            <div class="input-plus-absolute-right">
                                                <i @click="setResult('','clear',col.prop)" v-show="(col.selectedName!==''&&col.selectedName!==undefined)"  class="fa fa-minus color-red cursor-pointer"></i>
                                            </div>
                                            <ul class="new-dropdown autocomplete-results" v-show="col.isResultOpen=='true'">
                                                <li class="autocomplete-result" v-for='(result, index) in items' :key="index" @click="setResult(result,'organization',col.prop)">
                                                    {{result.name}}
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="wper-60" v-else-if="customFieldsProps.includes(col.prop)&&col.type=='9'" >
                                            <input type="text" class="form-control" :id="col.prop" @input="changeContactArray($event)" v-model="col.selectedName">
                                            <div class="input-plus-absolute-right">
                                                <i @click="setResult('','clear',col.prop)" v-show="(col.selectedName!==''&&col.selectedName!==undefined)"  class="fa fa-minus color-red cursor-pointer"></i>
                                            </div>
                                            <ul class="new-dropdown autocomplete-results" v-show="col.isResultOpen=='true'">
                                                <li class="autocomplete-result" v-for='(result, index) in items' :key="index" @click="setResult(result,'contact',col.prop)">
                                                    {{result.n}} {{result.sn}}
                                                </li>
                                            </ul>
                                        </div>
                                        <input v-else type="text" class="form-control" v-model="col.val" :aria-describedby="col.name">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <div class="col-12 dealBtnStyle p-0">
                                <button class="btn-new save" @click="updateDealsF()">{{$ml.get('BULK_UPDATE_BTN_TXT')}}</button>
                                <button class="btn-new" data-dismiss="modal" aria-label="Close">
                                    {{$ml.get('CANCEL')}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="modal fade" id="saveTableViewModal" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="savecollist" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content mcBgGrey">
                        <div class="modal-header border-0 mt-2 pb-0 align-items-center">
                            <h5 class="h5" id="saveColListModalTitle">{{$ml.get('SAVE_VIEW')}}</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true" class="font-40">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <label for="" class="">{{$ml.get('NAME_VIEW')}}</label>
                            <input type="text" class="form-control" v-model="newTableView.name">
                            
                        </div>
                        <div class="modal-footer">
                            <div class="col-12 dealBtnStyle p-0">
                                <button class="btn-new save" @click="saveTableViewF()">{{$ml.get('SAVE')}}</button>
                                <button class="btn-new" data-dismiss="modal" aria-label="Close">
                                    {{$ml.get('CANCEL')}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="confirmOverwriteModal" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="savecollist" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content mcBgGrey">
                        <div class="modal-header border-0 mt-2 pb-0 align-items-center">
                            <h5 class="h5" id="saveColListModalTitle">{{$ml.get('SAVE_VIEW')}}</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true" class="font-40">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <b>"{{selectedTableView.name}}" {{$ml.get('VIEW_ALREADY_EXIST')}}</b><br/>{{$ml.get('CONFIRM_OVERWRITE')}}
                            
                        </div>
                        <div class="modal-footer">
                            <div class="col-12 dealBtnStyle p-0">
                                <button class="btn-new save" @click="updateTableViewF()">{{$ml.get('SAVE')}}</button>
                                <button class="btn-new" data-dismiss="modal" aria-label="Close">
                                    {{$ml.get('CANCEL')}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="selectMethodModal" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="savecollist" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content mcBgGrey">
                        <div class="modal-header border-0 mt-2 pb-0 align-items-center">
                            <h5 class="h5" id="saveColListModalTitle">{{$ml.get('SAVE_VIEW')}}</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true" class="font-40">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            “{{selectedTableView.name}}” {{$ml.get('WHICH_WAY_TO_SAVE')}}
                        </div>
                        <div class="modal-footer">
                            <div class="col-12 dealBtnStyle p-0">
                                <button class="btn-new save mcBgDark" data-dismiss="modal" aria-label="Close" data-toggle="modal"  data-target="#saveTableViewModal" >
                                    {{$ml.get('SAVE_AS')}}
                                </button>
                                <button class="btn-new save" @click="updateTableViewF()">
                                    {{$ml.get('OVERWRITE')}}
                                </button>
                                <button class="btn-new" data-dismiss="modal" aria-label="Close">{{$ml.get('CANCEL')}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="colListModal" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="collist" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content mcBgGrey">
                        <div class="modal-header border-0 mt-2 pb-0 align-items-center">
                            <h5 class="h5" id="saveColListModalTitle">{{$ml.get('SAVED_VIEWS')}}</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true" class="font-40">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <ul class="list-group radio-list-group" >
                                <li class="list-group-item">
                                    <label for="" class="">
                                        <input type="radio" name="selectedview" v-model="selectedTableView" :value="defaultTableView"> {{$ml.get('DEFAULT_VIEW')}}
                                    </label>
                                </li>
                                <li class="list-group-item" v-for="(view,index) in tableViewList" v-bind:key="index">
                                    <label for="" class="">
                                        <input type="radio" name="selectedview" v-model="selectedTableView" :value="view" > {{view.name}}
                                    </label>
                                    <i class="fa fa-trash text-danger" @click="deleteTableViewF(view._id.$oid)"></i>
                                </li>
                            </ul>
                        </div>
                        <div class="modal-footer">
                            <div class="col-12 dealBtnStyle p-0">
                                <button class="btn-new save" v-if="tableViewList.length>0" @click="setTableViewF(selectedTableView._id.$oid)">
                                    {{$ml.get('APPLY')}}
                                </button>
                                <button class="btn-new" data-dismiss="modal" aria-label="Close">{{$ml.get('CANCEL')}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Import File Modal -->
            <div class="modal fade" id="importExcel" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog mw-100 w-75" role="document">
                    <div class="modal-content">
                        <takeImport :columns="gridColumns" :page="pageIs" :deleteUpdate="deleteUpdateDeals" @closeTakeModal="getDealsForList('emitter')"></takeImport> 
                    </div>
                </div>
            </div>




            <notifications group="foo" style="margin-right:5%;margin-top:5%" position="top right" />
        </div>
    </div>
</template>
<script>
import Header from '@/components/header'
import Grid from "./Grid";
import GridMobil from "./gridMobil";
import axios from "axios";
import Newdeal from './newDeal.vue'
import newOpportunity from './newOpportunity.vue'
import filterComponent from "./filterComponent.vue";
import takeImport from "./import.vue";
import { mapState } from "vuex";
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import Swal from 'sweetalert2'
import _ from 'underscore'
import dealsDashBoard from '@/components/dealsDashBoard'

export default {
    components: {
        Header,
        Grid,
        GridMobil,
        Newdeal,
        newOpportunity,
        filterComponent: filterComponent,
        'vue-ctk-date-time-picker': VueCtkDateTimePicker,
        dealsDashBoard,
        takeImport:takeImport
    },
    name: "Opportunities",
    data() {
        return {

            deleteUpdateDeals: false,
            
            type:"save",
            gridData: [],
            pagingSize: 40,
            pagingOffset: 0,
            deals:[],
            user:[],
            users:[],
            customFields:[],
            dealId:"",
            stageFilter:"all",
            oldStageId:"",
            filter:"",
            resultId:"",
            active:false,
            dealLoseSelect:0,
            dealLoseInput:"",
            okeyButtonActive:false,
            bottom:false,
            totalCount:0,
            modalClear:false,
            pageIs: "opportunities",
            permissions:[],
            tableConfigVisible:[],
            gridColumns: [
                { prop: "_id", name: "Id" },
                { prop: "x", name: this.$ml.get('STATUS'), type: "dealsStatus" },
                { prop: "stageId", name: this.$ml.get('STEP'), type: "step",default:true, valid:true},
                { prop: "orgId", name: this.$ml.get('COMPANY_NAME'), type: "dealsOrgName",default:true, valid:true  },
                { prop: "title", name: this.$ml.get('OPPORTUNITY_NAME'), type: "dealsName",default:true, valid:true },
                { prop: "value", name: this.$ml.get('VALUE'), type: "value",default:true },
                { prop: "rate", name: this.$ml.get('DEGREE'), type: "rate",default:true},
                { prop: "currency", name: this.$ml.get('CURRENCY'), type: "currency", valid:true },
                { prop: "contactId", name: this.$ml.get('CONTACT_PERSONS'), type: "contactDetail" },

                { prop: "discountPercentage", name: this.$ml.get('DISCOUNT_RATE'), default:false },
                { prop: "itemPrice", name:this.$ml.get("PRICE"), type:'price', default:false },
                { prop: "productList", name:this.$ml.get("RELATED_PRODUCT"), default:false },
                { prop: "quantity", name:this.$ml.get("QUANTITY"), default:false },

                { prop: "addDate", name: this.$ml.get('CREATION_DATE'), type: "dateObj",default:true  },
                { prop: "status", name: this.$ml.get('STATUS'), type: "dealStatus",default:true },
                { prop: "closedDate", name: this.$ml.get('CLOSING_DATE'), type: "dateObj",default:true },

                { prop: "cuid", name: this.$ml.get('HOLDER'), type: "user",default:true, valid:true },
                { prop: "expectedDate", name: this.$ml.get('ESTIMATED_CLOSING'), type: "dateObj",default:true },
                { prop: "source", name: this.$ml.get('SOURCE'), type: "source" },
                { prop: "notes", name: this.$ml.get('NOTES'), type: "note" }
            ],
            bulkEditableColumns: [
                { prop: "stageId", name: this.$ml.get('STEP'), val:"", type: "step" },//aşaması
                { prop: "expectedDate", name: this.$ml.get('ESTIMATED_CLOSING'), val:"", type: "dateObj" },//tahmini kapanış tarihi
                { prop: "rate", name: this.$ml.get('DEGREE'), val:"", type: "rate"},//öncelik
                { prop: "value", name: this.$ml.get('VALUE'), val:"", type: "value"},//değer
                { prop: "currency", name: this.$ml.get('CURRENCY'), val:"", type: "currency" },//para birimi
                { prop: "cuid", name: this.$ml.get('HOLDER'), val:"", type: "user" },//sahibi
                { prop: "source", name: this.$ml.get('SOURCE'), val:"", type: "source" },//kaynak
                { prop: "status", name: this.$ml.get('STATUS'), val:"", type: "dealStatus" },//durumu
            ],
            gridColumnsImport: [
                { prop: "_id", name: "Id" },
                { prop: "x", name: this.$ml.get('STATUS'), type: "dealsStatus" },
                { prop: "stageId", name: this.$ml.get('STEP'), type: "step",default:true },
                { prop: "orgId", name: this.$ml.get('COMPANY_NAME'), type: "dealsOrgName",default:true },
                { prop: "title", name: this.$ml.get('OPPORTUNITY_NAME'), type: "dealsName",default:true },
                { prop: "value", name: this.$ml.get('VALUE'), type: "value",default:true },
                { prop: "rate", name: this.$ml.get('DEGREE'), type: "rate",default:true},
                { prop: "currency", name: this.$ml.get('CURRENCY'), type: "currency" },
                { prop: "contactId", name: this.$ml.get('CONTACT_PERSONS'), type: "contactDetail" },
                { prop: "addDate", name: this.$ml.get('CREATION_DATE'), type: "dateObj" },
                { prop: "cuid", name: this.$ml.get('HOLDER'), type: "user",default:true },
                { prop: "expectedDate", name: this.$ml.get('ESTIMATED_CLOSING'), type: "dateObj",default:true },
                { prop: "source", name: this.$ml.get('SOURCE'), type: "source" },
                { prop: "notes", name: this.$ml.get('NOTES'), type: "note" },
                { prop: "status", name: this.$ml.get('STATUS'), type: "dealStatus",default:true },
                { prop: "closedDate", name: this.$ml.get('CLOSING_DATE'), type: "dateObj",default:true }
            ],
            selectedTableView:{
                _id:{$oid:''}
            },
            newTableView:{
            },
            defaultTableView:{
                name:this.$ml.get('DEFAULT_VIEW'),
                _id:{$oid:'default-view'}
            },
            tableViewList:[],
            sort:null,
            sortType:null,
            totalValue:0,
            stageInfo:[],
            dashBoard:[],
            firstLoad:true,
            dealStepList:[
                {value:1,label:this.$ml.get('STEP_1')},
                {value:2,label:this.$ml.get('STEP_2')},
                {value:3,label:this.$ml.get('STEP_3')},
                {value:4,label:this.$ml.get('STEP_4')},
            ],
            soruceTitle: [
                {value: '0', label: this.$ml.get('SELECT')},
                {value: 'Reklam', label:  this.$ml.get('ADVERTISING')},
                {value: 'Telefon Araması', label: this.$ml.get('PHONE_CALL')},
                {value: 'Çalışan Yönlendirmesi', label: this.$ml.get('EMPLOYEE_ORUENTATION')},
                {value: 'Dışarıdan Yönlendirme', label: this.$ml.get('EXTERNAL_ORUENTATION')},
                {value: 'Online Mağaza', label: this.$ml.get('ONLINE_STORE')},
                {value: 'İş Ortağı', label: this.$ml.get('BUSINES_PARTNER')},
                {value: 'Halkla İlişkiler', label: this.$ml.get('PUBLIC_RELATIONS')},
                {value: 'Seminer', label: this.$ml.get('SEMINAR')},
                {value: 'Fuar', label: this.$ml.get('FAIR')},
                {value: 'Web', label: "Web"},
                {value: 'Anlık Mesajlaşma', label: this.$ml.get('INSTANT_MESSAGING')}
            ],
            statusTitle:[
                {value:1,label: this.$ml.get('OPEN')},
                {value:2,label: this.$ml.get('WON')},
                {value:3,label: this.$ml.get('NOT_WON')}
            ],
            rateTitle:[
                {value: 1, label: this.$ml.get('NORMAL')},
                {value: 2, label: this.$ml.get('PRIORITY')},
                {value: 3, label: this.$ml.get('URGENT')},
            ],
            customFieldsProps:[],
            items:[],
            checkedRows:[],
            checkAllRows:false,
            popoverDelay:{ show: 500, hide: 300 },
            popoverTrigger:"hover",
            dashInfo:[],
            defaultCurrency:localStorage.defaultCurrency
        }
    },
    computed: {
        ...mapState(['baseUrl', "editLine", "editLineStatu","windowWidth","maxMobilSize","maxTabletSize"]),
        ...mapGetters(['localeLang']),
        listenState() {
        return this.$store.state.editLine;
        },
        listenStateStatus() {
        return this.$store.state.editLineStatu;
        },
        bulkEditableColumnsCleaned(){
            return this.bulkEditableColumns.filter(item => item.prop!=='currency')
        },
    },
    watch: {
        bottom(bottom) {
            if (bottom) {
                this.pagingOffset += this.pagingSize;
                this.getDealsForList();
            }
        },
        permissions: function() {
            if (this.permissions === undefined) {
            this.permissions = [];
            }
        },
        stageFilter:function(){
            this.$refs.filter.childFilter(this.stageFilter,"stageId");
        },
    },
    methods:{
        formatPrice: function(val){
            if(val!==undefined && val!==null && !isNaN(val)){
                return Number(val).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1\,")
            }
            return ''
        },
        filterName:function(value){
            if ( value && value.length > 20 ) {
                return value.substring(0,20) + '...'
            } else {
                return value || ''
            }
        },
        filterChooseName:function(value){
            if ( value && value.length > 15 ) {
                return value.substring(0,15) + '...'
            } else {
                return value || ''
            }
        },
        getFullNameOfContact(contact){
            var name=''
            var sname=''
            if(contact && contact.n!==""&&contact.n!==undefined&&contact.n!==null){
                name = contact.n
            }
            if(contact && contact.sn!==""&&contact.sn!==undefined&&contact.sn!==null){
                sname = contact.sn
            }
            return (name+' '+sname).trim()
        },
        toFix: function(val){
            if(val!==undefined && val!==null && !isNaN(val)){
                return Number(val).toFixed(2);
            }
            return ''
        },
        toPriceModel:function(price){
            if(price!==undefined && price!==null){
                return price.toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1\,")
            }
            return ''
        },
        arrayToString:function(arr,options,id=null){
            var lblList = []
            if (options && Array.isArray(options)) {
                options.filter(function(op) {
                    if(id=='5e37d810ff4a85001840e559'){
                        if(op.id==arr){
                            lblList.push(op.label)
                        }
                    }
                    else{
                        for(var l in arr){
                            if(op.id==arr[l]){
                                lblList.push(op.label)
                            }
                        }
                    }
                })
            }
            if ( lblList.toString().length > 15 ) {
                return lblList.toString().substring(0,15) + '...'
            } else {
                return lblList.toString()
            }
        },

        opportunityImportBtn(){
            // console.log('&& opportunityImportBtn girildi &&')
            $('#importExcel').modal()
        },

        currenciesList(stage){
            if(stage=='total'){
                var totalPrices = []
                for(var i in this.dashInfo){
                    for(var j in this.dashInfo[i].prices){
                        totalPrices.push(this.dashInfo[i].prices[j])
                    }
                }
            
                const newTotal = Object.values(totalPrices.reduce((acc, {price,count , ...r}) => {
                    var key = Object.entries(r).join('-');
                    acc[key] = (acc[key]  || {...r, price:0,count: 0});
                    return (acc[key].price += price, acc[key].count += count, acc);
                }, {}));

                totalPrices = newTotal

                return totalPrices
            }else if(stage==1 || stage==2 || stage==3 || stage==4 || stage==5){
                if(this.dashInfo!==undefined){
                    var list = this.dashInfo.find(info=>info._id==stage)
                    if(list){
                        return list.prices
                    }else{
                        return []
                    }
                }else{
                    return []
                }
                
            }
            
        },
        updateCheckedRows(val){
            if(val=='allRowsChecked'){
                this.checkAllRows=true
                this.checkedRows = []
            }else{
                this.checkAllRows=false
                this.checkedRows = val
            }
            
        },
        deleteSelectedRows(){
            if(this.checkedRows.length==0&&this.checkAllRows==false){
                Swal.fire({
                    title: this.$ml.get('WARNING'),
                    text: this.$ml.get('NO_SELECTED_ROW_ON_DELETE'),
                    icon: "warning",
                    showCancelButton: true,
                })
                return false
            }

            var form = {}

             if(this.checkAllRows==true&&this.filter==''){
                form.all = true
            }else if(this.checkedRows.length>0){
                form.dealIds = this.checkedRows
            }
            
            if(this.filter!==''&&this.checkedRows.length==0){
                form.filter = this.filter
            }
            var confirm_message = this.$ml.get('DELETE_RECORDS_CONFIRM')
            if(this.$can('can_bulk_delete_deals')&&this.$can('can_delete_other_users_deals')){
                console.log("hepsini silebilir")
                confirm_message = this.$ml.get('DELETE_RECORDS_CONFIRM')
            }else if(!this.$can('can__bulk_delete_deals')&&this.$can('can_delete_other_users_deals')){
                //sadece başkasının itemlerini silebilir
                console.log("sadece başkasının itemlerini silebilir")
                confirm_message = this.$ml.get('DELETE_RECORDS_CONFIRM_OTHERS')
            }else if(this.$can('can_bulk_delete_deals')&&!this.$can('can_delete_other_users_deals')){
                //sadece kendi itemlerini silebilir
                console.log("sadece kendi itemlerini silebilir")
                confirm_message = this.$ml.get('DELETE_RECORDS_CONFIRM_OWN')
            }

            Swal.fire({
                title: this.$ml.get('DELETE_RECORDS'),
                text: confirm_message,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: '#d33',
                confirmButtonText: this.$ml.get('DELETE_RECORDS_CONFIRM_BTN_TXT'),
                cancelButtonText: this.$ml.get('CANCEL'),
                customClass:{
                    icon:'custom-delete-warning',
                    cancelButton:'custom-delete-cancel-button'
                },
                reverseButtons:true
            }).then((result)=>{
                if(result.isConfirmed){
                    this.deleteDeals(form).then((response)=>{
                        if(response.status.code=='0'){
                            this.$notify({ 
                                group: 'foo',
                                type: 'success', 
                                title: this.$ml.get('SUCCESSFUL'),
                                text: response.status.desc 
                            })
                            this.getDealsDashboard()
                            this.getDealsForList('emitter')
                        }else{
                            this.$notify({ 
                                group: 'foo',
                                type: 'error', 
                                title: this.$ml.get('ERROR'),
                                text: response.status.desc 
                            })
                        }
                    })
                }
            })
            
        },
        changeContactArray: _.debounce(function(event) {

            var name=event.target.value
            var cfid=event.target.id
 
            if(name!=""){
                this.quickContact(name)
                this.bulkEditableColumns.find(cf => cf.prop==cfid ).isResultOpen = 'true'
            }else{
                this.bulkEditableColumns.find(cf => cf.prop==cfid ).isResultOpen = 'false'
            }

        },300),
        changeOrganizationArray: _.debounce(function(event) {

            var name=event.target.value
            var cfid=event.target.id
 
            if(name!=""){
                this.quickOrganization(name) 
                this.bulkEditableColumns.find(cf => cf.prop==cfid ).isResultOpen = 'true'
            }else{
                this.bulkEditableColumns.find(cf => cf.prop==cfid ).isResultOpen = 'false'
            }

        },300),
        setRadio(cfid,type,event){
            if(type=='clear'){
                this.bulkEditableColumns.find(cf => cf.prop==cfid ).val = []
                this.bulkEditableColumns.find(cf => cf.prop==cfid ).radioVal = ''
            }

            if(type=='setvalue'){
                this.bulkEditableColumns.find(cf => cf.prop==cfid ).val = []
                this.bulkEditableColumns.find(cf => cf.prop==cfid ).val=event.target.value
               
              
            }
        },
        setResult(result,type,cfid){
            if(type=="clear"){
                this.bulkEditableColumns.find(cf => cf.prop==cfid ).val = ''
                this.bulkEditableColumns.find(cf => cf.prop==cfid ).selectedName = ''
                this.bulkEditableColumns.find(cf => cf.prop==cfid ).isResultOpen = 'false'
            }
            if(type==="contact"){
                this.bulkEditableColumns.find(cf => cf.prop==cfid ).val = result._id.$oid
                this.bulkEditableColumns.find(cf => cf.prop==cfid ).selectedName = this.getFullNameOfContact(result)
                this.bulkEditableColumns.find(cf => cf.prop==cfid ).isResultOpen = 'false'
            }
            if(type==="organization"){
                this.bulkEditableColumns.find(cf => cf.prop==cfid ).val = result._id.$oid
                this.bulkEditableColumns.find(cf => cf.prop==cfid ).selectedName = this.filterName(result.name)
                this.bulkEditableColumns.find(cf => cf.prop==cfid ).isResultOpen = 'false'
            }
        },
        quickContact(name){
             
            axios({
                method:'POST',
                url:'/quickFilterContact',
                baseURL: this.baseUrl,
                data: {
                    search:name,
                    //organizationId:this.organizationId
                },
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(!res.data.status){
                    this.$router.push('/logout')
                }
                if(res.data.status.code==0){
                    this.items=res.data.content.contacts
                }
                 
            })
        },
        quickOrganization(name){
             
            axios({
                method:'POST',
                url:'/quickFilterOrganization',
                baseURL: this.baseUrl,
                data: {
                    search:name,
                },
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(!res.data.status){
                    this.$router.push('/logout')
                }
                if(res.data.status.code==0){
                    this.items=res.data.content.organizations
                }
                 
            })
        },
        updateDealsF(){
            var form = {}

            form.dealUpdateObj = {}
            for(var obj in this.bulkEditableColumns){
                var prop = this.bulkEditableColumns[obj].prop
                var val = this.bulkEditableColumns[obj].val
                var type = this.bulkEditableColumns[obj].type
                
                if(val!==''&&val!==undefined&&typeof(val)!=='object'){
                    if(type=='dateObj'||type=='3'){
                        var dateObject ={}
                        dateObject['$date'] = new Date (val)
                        form.dealUpdateObj[prop] = dateObject
                    }else if(type=='user'||type=='4'){
                        var userObject = {}
                        userObject['$oid'] = val
                        form.dealUpdateObj[prop] = userObject
                    }else{
                        form.dealUpdateObj[prop] = val
                    }
                }else if(typeof(val)=='object'&&val.length>0){
                        form.dealUpdateObj[prop] = val
                }
            }

            if(this.checkAllRows==true&&this.filter==''){
                form.all = true
            }else if(this.checkedRows.length>0){
                form.dealIds = this.checkedRows
            }
            
            if(this.filter!==''&&this.checkedRows.length==0){
                form.filter = this.filter
            }
            
            this.updateDeals(form).then((response) => {
                
                if(response.status.code=='0'){
                    this.$notify({ 
                        group: 'foo',
                        type: 'success', 
                        title: this.$ml.get('SUCCESSFUL'),
                        text: response.status.desc 
                    })
                    this.getDealsDashboard()
                    this.getDealsForList('emitter')
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: response.status.desc 
                    })
                }
                this.closeBulkUpdateModal()
            }).catch(e => {
                console.log(e)
            })
            
        },
        openBulkUpdateModal(){
            if(this.checkedRows.length==0&&this.checkAllRows==false){
                Swal.fire({
                    title: this.$ml.get('WARNING'),
                    text: this.$ml.get('NO_SELECTED_ROW_ON_UPDATE'),
                    icon: "warning"
                })
            }else if(this.checkAllRows==true&&this.filter==''){
                Swal.fire({
                    title: this.$ml.get('WARNING'),
                    text: this.$ml.get('UPDATE_ALL_RECORDS_CONFIRM'),
                    icon: "warning",
                    buttons: true,
                    dangerMode:true
                }).then((result)=>{
                    if(result.isConfirmed){
                        $('#bulkUpdate').modal('show')
                    }
                })
                
            }else{
                $('#bulkUpdate').modal('show')
            }
            
        },
        closeBulkUpdateModal(){
            $('#bulkUpdate').modal('hide')
            this.clearBulkUpdateModal()
        },
        clearBulkUpdateModal(){
            for(var i in this.bulkEditableColumns){
                //var val = this.bulkEditableColumns[i].val
                var type = this.bulkEditableColumns[i].type
                if(type!==7){
                    this.bulkEditableColumns[i].val = ''
                }else{
                    this.bulkEditableColumns[i].val = []
                }
            }
        },
        getDealsDashboard(){
            axios({
                method:'POST',
                url:'/getDealsDashboard',
                baseURL: this.baseUrl,
                withCredentials:true
                }).then((res)=>{
                    return res
                }).then((res)=>{                  
                    if(res.data.status.code==="0"){
                        this.dashBoard=res.data.content.dealsDashboard
                      
                    }else{
                        this.$notify({ 
                            group: 'foo',
                            type: 'error', 
                            title: this.$ml.get('ERROR'),
                            text: res.data.status.desc 
                        })
                    }
                 
            })
        },
        getSortedData(form){
            this.sort=form.sort
            this.sortType=form.sortType
            this.getDealsForList('emitter')
        },
        clearModal(){
            if (this.editLineStatu) {
                this.getDealsForList("emitter");
            }
            let statu = false;
            this.$store.dispatch("editLineStatu", statu);
            this.clearModal = true;
        },
        scrollfunctionOfGrid:function (scrollYEmit,clientHeightEmit,scrollHeightEmit){
            this.bottom = this.bottomVisible(scrollYEmit,clientHeightEmit,scrollHeightEmit)
        },
        bottomVisible(scrollYEmit,clientHeightEmit,scrollHeightEmit) {
            
            const scrollY = scrollYEmit
            const visible = clientHeightEmit
            const pageHeight = scrollHeightEmit
            const bottomOfPage = visible + scrollY >= pageHeight
            
            return bottomOfPage || pageHeight < visible
        },
        getData(event) {
            let obj = {};

            let productObj = event;
            let columns = this.gridColumns;

            for (var column in columns) {
                var colInProduct = productObj.hasOwnProperty(columns[column]["prop"]);

                if (colInProduct) {
                let edObj = {};

                edObj["val"] = productObj[columns[column]["prop"]];
                edObj["isEditMode"] = false;
                edObj["type"] = columns[column]["type"];

                obj[columns[column]["prop"]] = edObj;
                } else {
                let edObj = {};

                edObj["val"] = null;
                edObj["isEditMode"] = false;
                edObj["type"] = columns[column]["type"];
                obj[columns[column]["prop"]] = edObj;
                }
            }

            this.totalCount = this.totalCount + 1;
        },
        getDealsForList(emitter){
             
            if(this.windowWidth<this.maxMobilSize){
                this.gridColumns= [
                    { prop: "_id", name: "Id" },
                    { prop: "stageId", name: this.$ml.get('STEP'), type: "step",default:true },
                    { prop: "expectedDate", name: this.$ml.get('ESTIMATED_CLOSING'), type: "dateObj",default:true },
                    { prop: "orgId", name: this.$ml.get('COMPANY_NAME'), type: "dealsOrgName",default:true },
                    { prop: "title", name: this.$ml.get('OPPORTUNITY_NAME'), type: "dealsName",default:true },
                    { prop: "value", name: this.$ml.get('VALUE'), type: "value",default:true },
                    { prop: "currency", name: this.$ml.get('CURRENCY'), type: "currency" },
                    { prop: "rate", name: this.$ml.get('DEGREE'), type: "rate",default:true},
                    { prop: "addDate", name: this.$ml.get('CREATION_DATE'), type: "dateObj" },
                    { prop: "cuid", name: this.$ml.get('HOLDER'), type: "user",default:true },
                ]
            }            

            if(emitter!==undefined){
                this.pagingOffset=0
                if(screen.height>720){
                    this.pagingSize=30
                }else{
                    this.pagingSize=10
                }
            }
            var params = {}
            params.pagingSize=this.pagingSize
            params.pagingOffset=this.pagingOffset
            params.filter=this.filter
            if(this.sort!=null){
                params.sort=this.sort
            }
            if(this.sortType!=null){
                params.sortType=this.sortType
            }
            axios({
                method:'POST',
                url:'/getDealsForList',
                baseURL: this.baseUrl,
                data: params,
                withCredentials:true
            }).then((res)=>{
                    return res
            }).then((res)=>{
                if(!res.data.status){
                    this.$router.push('/logout')
                }
                if(res.data.status.code==0){

                    if(emitter!==undefined){
                        this.deals=[]
                    }
                    this.totalValue=0
                    this.stageInfo=[]
                    this.dashInfo = res.data.content.dashInfo
                    for(var stage in res.data.content.dashInfo){
                        this.totalValue=this.totalValue+res.data.content.dashInfo[stage]['totalValue']
                        this.stageInfo[res.data.content.dashInfo[stage]['_id']]=res.data.content.dashInfo[stage]
                       
                    }
                    this.totalValue=parseInt(this.totalValue)
                    this.totalCount = res.data.content.pageInfo["totalCount"];

                    if (res.data.content.customFields) {
                        for (var item in res.data.content.customFields) {
                            let obj = {};

                            obj["prop"] =
                            res.data.content.customFields[item]["_id"]["$oid"];
                            this.customFieldsProps.push(res.data.content.customFields[item]["_id"]["$oid"])
                            obj["name"] = res.data.content.customFields[item]["name"];
                            obj["type"] = res.data.content.customFields[item]["field_type"];
                            obj["val"] = ""
                            if (res.data.content.customFields[item]["field_type"] == 4) {
                                obj["users"] = res.data.users;
                            } else if (
                            res.data.content.customFields[item]["field_type"] == 7 ||
                            res.data.content.customFields[item]["field_type"] == 6
                            ) {
                                obj["options"] = res.data.content.customFields[item]["options"];
                                obj["val"] = []
                                
                            }
                            
                            if (res.data.content.customFields[item]["field_type"] == 6 ){
                                obj["radioVal"] = ''
                            }

                            var existingColCount = this.gridColumns.filter(function(i) {
                            if (i.name === res.data.content.customFields[item]["name"])
                                return i.name;
                            });

                            if (existingColCount.length < 1) {
                            this.gridColumns.push(obj);
                            this.bulkEditableColumns.push(obj);
                            }
                        }
                    }
                    /*
                    if(this.firstLoad){
                        if(this.selectedTableView._id.$oid=='default-view'){
                            this.setDefaultTableViewF()
                        }
                    }*/
                    this.firstLoad=false

                    if (res.data.content.deals) {

                        let columns = this.gridColumns;

                        for (var productObjIter in res.data.content.deals) {
                            let obj = {};

                            let productObj = res.data.content.deals[productObjIter];

                            for (var column in columns) {
                                var colInProduct = productObj.hasOwnProperty(
                                    columns[column]["prop"]
                                );

                                if (colInProduct) {
                                let edObj = {};
                                if(columns[column]['type']=='user'){
                                        edObj['users']=this.users
                                        columns[column]['users']=this.users
                                }
                                if(columns[column]['type']=='value'){
                                    edObj["val"] =  this.formatPrice(productObj[columns[column]["prop"]])
                                }else{
                                    edObj["val"] = productObj[columns[column]["prop"]];
                                }
                                
                                edObj["isEditMode"] = false;
                                edObj["type"] = columns[column]["type"];

                                obj[columns[column]["prop"]] = edObj;
                            } else {
                                let edObj = {};

                                edObj["val"] = null;
                                edObj["isEditMode"] = false;
                                edObj["type"] = columns[column]["type"];
                                if (columns[column]["type"] == "price") {
                                let pricesList = [];
                                let priceObj = {};
                                priceObj["currency"] = null;
                                priceObj["price"] = null;
                                pricesList.push(priceObj);
                                edObj["val"] = pricesList;
                                } else if (columns[column]["type"] == 4) {
                                let oid = {};
                                oid["$oid"] = "";
                                edObj["val"] = {};
                                edObj["val"]["_id"] = oid;
                                } else if (columns[column]["type"] == 5) {
                                let priceObj = {};
                                priceObj["currency"] = "";
                                priceObj["value"] = "";
                                edObj["val"] = priceObj;
                                } else if (columns[column]["type"] == 6) {
                                let selected = "";
                                edObj["val"] = selected;
                                } else if (columns[column]["type"] == 7) {
                                let optionsList = [];
                                edObj["val"] = optionsList;
                                } else if (columns[column]["type"] == "country") {
                                edObj["val"] = "";
                                } else if (columns[column]["type"] == "isCandidate") {
                                edObj["val"] = "";
                                }

                                obj[columns[column]["prop"]] = edObj;
                            }
                        }

                        this.deals.push(obj);
                        
                        }

                        this.gridData = this.deals;
                    }
                    
                    this.customFields=res.data.content.customFields
                    this.user=res.data.user
                    this.users=res.data.users
                    this.permissions=res.data.permissions
                   
                    
                     
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc 
                    })
                     
                }
            })
        },
        detail(id){
            if(id!==""){
                localStorage.dealId=id
                this.updateDealId(id)
                window.open('/dealCard/'+id, '_blank');
            }
        },
        organizationCard(id){
            if(id!==""){
                localStorage.orgId=id
                this.updateOrgId(id)
                window.open('/organizationCard/'+id, '_blank');
            }
        },
        contactCard(id){
            if(id!==""){
                localStorage.contactId=id
                this.updateContactId(id)
                window.open('/contactCard/'+id, '_blank');
            }
        },
        getTableViewF(){
            var form = {}
            form.tableName = 'deals'
            this.getTableView(form).then((res)=>{
                return res
            }).then((res)=>{
                if(res.status.code=='0'){
                    this.tableViewList = res.content.tableViews

                    if(this.tableViewList.length>0){
                        
                        var getSelectedCustomView = this.tableViewList.filter(view => view.isDefault ==true)[0]
                        
                        if(getSelectedCustomView==undefined){
                            this.setDefaultTableViewF()
                        }else{
                            this.selectedTableView = getSelectedCustomView
                            this.tableConfigVisible = this.selectedTableView.fields
                        }
                        
                    }else{
                        this.setDefaultTableViewF()
                    }
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: res.status.desc 
                    })
                }
            })
        },
        setDefaultTableViewF(){
            // for(var col in this.gridColumns){
            //     if(this.gridColumns[col]['default']){
            //         this.tableConfigVisible.push(this.gridColumns[col]['prop'])
            //     }
            // }
            
            var defaultViews = this.gridColumns.filter(col => col.default == true).map(item => item.prop)
            
            
            this.tableConfigVisible = defaultViews
            
            this.defaultTableView.fields = this.tableConfigVisible
            this.defaultTableView.name = this.$ml.get('DEFAULT_VIEW')
            this.selectedTableView = this.defaultTableView
        },
        setTableViewF(tableViewId){

            if(tableViewId == 'default-view'){
                //this.setDefaultTableViewF()

                var form = {}
            
                form.tableViewId = this.tableViewList.filter(view => view.isDefault ==true)[0]._id.$oid
                form.isDefault = false
                this.updateTableView(form).then((res)=>{
                    return res
                }).then((res)=>{
                    if(res.status.code=="0"){
                        this.$notify({ 
                            group: 'foo',
                            type: 'success', 
                            title: this.$ml.get('SUCCESSFUL'),
                            text: res.status.desc 
                        })
                        $('#colListModal').modal('hide')
                        this.getTableViewF()
                    }else{
                        this.$notify({ 
                            group: 'foo',
                            type: 'error', 
                            title: this.$ml.get('ERROR'),
                            text: res.status.desc 
                        })
                    }
                })
            }else{
                var theView = this.tableViewList.filter((item)=>{
                    return item._id.$oid == tableViewId
                })
                var form = {}
                this.tableConfigVisible = theView[0].fields
                this.selectedTableView = theView[0]
                
                form.tableViewId = this.selectedTableView._id.$oid
                form.isDefault = true
                this.updateTableView(form).then((res)=>{
                    return res
                }).then((res)=>{
                    if(res.status.code=="0"){
                        this.$notify({ 
                            group: 'foo',
                            type: 'success', 
                            title: this.$ml.get('SUCCESSFUL'),
                            text: res.status.desc 
                        })
                        $('#colListModal').modal('hide')
                        this.getTableViewF()
                    }else{
                        this.$notify({ 
                            group: 'foo',
                            type: 'error', 
                            title: this.$ml.get('ERROR'),
                            text: res.status.desc 
                        })
                    }
                })
            } 
        },
        selectSaveMethod(){
            if(this.selectedTableView._id.$oid=='default-view'&&this.tableViewList.length==0){
                $('#saveTableViewModal').modal('show')
            }else{
                $('#selectMethodModal').modal('show')
            }
        },
        saveTableViewF(){
            
            var actualName = this.newTableView.name
            var duplicatedNames = this.tableViewList.filter((item)=>{
                return item.name == actualName
            })
            
            if(duplicatedNames.length>0){
                $('#saveTableViewModal').modal('hide')
                $('#confirmOverwriteModal').modal('show')
            }else if(actualName=='Standart görünüm'||actualName=='Default view'){
                Swal.fire({
                    title: this.$ml.get('WARNING'),
                    text: this.$ml.get('ENTER_ANOTHER_NAME'),
                    icon: 'warning'
                })
            }else{
                this.addTableViewF()
            }
            
        },
        addTableViewF(){
            var form = {}
            form.fields = this.tableConfigVisible
            form.tableName = 'deals'
            form.name = this.newTableView.name
            form.isDefault = false
            this.addTableView(form).then((res)=>{
                return res
            }).then((res)=>{
                if(res.status.code=="0"){
                    this.$notify({ 
                        group: 'foo',
                        type: 'success', 
                        title: this.$ml.get('SUCCESSFUL'),
                        text: res.status.desc 
                    })
                    $('#saveTableViewModal').modal('hide')
                    $('#confirmOverwriteModal').modal('hide')
                    this.getTableViewF()
                }
            })
        },
        updateTableViewF(){
            var form = {}
            form.fields = this.tableConfigVisible
            form.tableViewId = this.selectedTableView._id.$oid
            form.name = this.selectedTableView.name
            form.isDefault = this.selectedTableView.isDefault
            this.updateTableView(form).then((res)=>{
                return res
            }).then((res)=>{
                if(res.status.code=="0"){
                    this.$notify({ 
                        group: 'foo',
                        type: 'success', 
                        title: this.$ml.get('SUCCESSFUL'),
                        text: res.status.desc 
                    })
                    $('#saveTableViewModal').modal('hide')
                    $('#selectMethodModal').modal('hide')
                    $('#confirmOverwriteModal').modal('hide')
                    this.getTableViewF()
                }
            })
        },
        deleteTableViewF(tableViewId){
            Swal.fire({
                title: this.$ml.get('DELETE_RECORD'),
                text: this.$ml.get('DELETE_TABLE_VIEW_CONFIRM'),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: '#d33',
                confirmButtonText: this.$ml.get('DELETE_RECORD_CONFIRM_BTN_TXT'),
                cancelButtonText: this.$ml.get('CANCEL'),
                customClass:{
                    icon:'custom-delete-warning',
                    cancelButton:'custom-delete-cancel-button'
                },
                reverseButtons:true
            }).then((result)=>{
                if(result.isConfirmed){
                    var form = {}
                    form.tableViewId = tableViewId
                    this.deleteTableView(form).then((res)=>{
                        return res
                    }).then((res)=>{
                        if(res.status.code=="0"){
                            this.$notify({ 
                                group: 'foo',
                                type: 'success', 
                                title: this.$ml.get('SUCCESSFUL'),
                                text: res.status.desc 
                            })
                            this.getTableViewF()
                        }
                    })
                }
            })
        },
        clearSaveTableViewModal(){
            this.newTableView={}
        },
        ...mapActions([
            'updateDealId',
            'updateOrgId',
            'updateContactId',
            'updateLoading',
            'updateDeals',
            'deleteDeals',
            'getTableView',
            'addTableView',
            'deleteTableView',
            'updateTableView'
        ])
    },
    mounted() {

        $("#mytabs").bootstrapDynamicTabs();
        $(this.$refs.dealModal).on("hidden.bs.modal", this.clearModal);
        $('#bulkUpdate').on('hidden.bs.modal',this.clearBulkUpdateModal);
        $('#colListDDD').on('hide.bs.dropdown', function (e) {
            console.log("e.clickEvent.target.className")
            console.log(e.clickEvent.target)
            if (e.clickEvent ) {
                e.preventDefault();
            }
        });
        $('#saveTableViewModal').on('hide.bs.modal', this.clearSaveTableViewModal);
        
        if (screen.height > 720) {
        this.pagingSize = 40;
        } else {
        this.pagingSize = 30;
        }
    },
    created(){
        this.getDealsDashboard()
        this.getDealsForList();
        this.getTableViewF()
    }
}
</script>
<style scoped>
.price-list > .list-group-item{
    padding:5px;
}
.stageFilterBorder{
    border: 1px solid #DEDFE1;
    padding: 4px;
}
.staceFilterPrice{
    background-color: #E9EDF5;
    border-radius: 4px;
}

.h40{
    height: 40px;
}
.w40{
    width: 40px;
}
.filtreAndTableSetting{
    background-color: transparent;
    box-sizing: border-box;
    padding: 0px 0px 8px 0px;
    border-bottom: 0;
}

.price-list .curr-shortcode{
    width: 25%;
}
.p-list-title{
    padding-left:5px;
}
.v-popover{
    cursor:context-menu;
    display: inline-block;
}
.stageFilter button{
    color: #333;
    background-color: #fafafa;
}
.step0{
    background-color: #94C2FC;
    color: white;
    width: 137px
}
.step1{
    background-color: #66A2EC;
    color: white;
    border-radius: 0px;
    margin-left: -6px;
    height: 52px !important;
    width: 137px
}
.step2{
    background-color: #5088D2;
    color: white; 
    border-radius: 0px;
    margin-left: -4px; 
    height: 52px !important;
    width: 137px
}
.step3{
    background-color: #3E6AA3;
    color: white;
    border-radius: 0px;
    margin-left: -4px;
    height: 52px !important; 
    width: 137px
}
.step4{
    background-color: #2B4C75;
    color: white;
    border-radius: 0px;
    margin-left: -4px;
    height: 52px !important; 
    width: 137px
}
.step5{
    background-color: #14345A;
    color: white;
    margin-left: -6px; 
    height: 52px !important;
    width: 137px
}
/* .w130{
    width: 120px !important;
} */

.stageFilter .active b, .stageFilter button:hover .staceFilterPrice{
    color: #5A6376 !important;
}

.stageFilter .active, .stageFilter button:hover{
    background-color: #1991EB;
    color: white;
}
.hiza{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
}

.modal-xl{
    max-width: 1140px;
}
.input-group-prepend{
    min-width: 40%;
}
.input-group-text{
    min-width: 100%;
}
.wper-60{
    width: 60%;
}
.input-like-dd-button{
    width: 100%;
    height: 100%;
    text-align: left;
    background-color: white;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}
.input-like-dd-button:focus{
    outline-color:#ced4da ;
}
.dd-footer{
    background-color: #CEDAE7;
}
.btn-green {
    color: #fff;
    background-color: #28a745 !important;
    border-color: #28a745 !important;
}
.radio-list-group li.list-group-item{
    background: transparent;
    border-top:0;
    border-right:0;
    border-left:0;
}
.radio-list-group li.list-group-item:last-child{
    border-bottom:0;
}
.radio-list-group li.list-group-item i{
    position: absolute;
    right:10px;
    cursor: pointer;
}
.radio-list-group li.list-group-item label{
    margin-bottom:0;
}
@media (max-width: 992px){
.step0, .step1, .step2, .step3, .step4, .step5{
    height: 31px !important;
}
.step0{
    width: 61.42px;
}
.step1{
    width: 82.89px;
}
.step2{
    width: 111.69px;
}
.step3{
    width: 59.86px;
}
.step4{
    width: 116.88px;
}
}
@media (max-width: 768px){
    .stageFilter .active,.stageFilter button:hover{
        background-color: #1991EB;
        color: white;
    }
    .stageFilter > button {
        margin-right: 10px;
        background: transparent;
        color: #53565E;
        border: 1px solid rgba(0, 0, 0, 0.1);
        border-radius: 4px;
    }
    .btn-crm-secondary {
        background-color: #f2f2f2 !important;
    }
    
}
</style>
